import { render, staticRenderFns } from "./warehouse-products-value-dialog.vue?vue&type=template&id=23c12e1b&"
import script from "./warehouse-products-value-dialog.vue?vue&type=script&lang=js&"
export * from "./warehouse-products-value-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports